import { loadBasic } from "@tsparticles/basic";
import { options } from "./options.js";
export async function loadStarsPreset(engine, refresh = true) {
    await loadBasic(engine, false);
    await engine.addPreset("stars", options, false);
    await engine.refresh(refresh);
}
